var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 12.8798V11.1198C2 10.0798 2.85 9.21981 3.9 9.21981C5.71 9.21981 6.45 7.93981 5.54 6.36981C5.02 5.46981 5.33 4.29981 6.24 3.77981L7.97 2.78981C8.76 2.31981 9.78 2.59981 10.25 3.38981L10.36 3.57981C11.26 5.14981 12.74 5.14981 13.65 3.57981L13.76 3.38981C14.23 2.59981 15.25 2.31981 16.04 2.78981L17.77 3.77981C18.68 4.29981 18.99 5.46981 18.47 6.36981C17.56 7.93981 18.3 9.21981 20.11 9.21981C21.15 9.21981 22.01 10.0698 22.01 11.1198V12.8798C22.01 13.9198 21.16 14.7798 20.11 14.7798C18.3 14.7798 17.56 16.0598 18.47 17.6298C18.99 18.5398 18.68 19.6998 17.77 20.2198L16.04 21.2098C15.25 21.6798 14.23 21.3998 13.76 20.6098L13.65 20.4198C12.75 18.8498 11.27 18.8498 10.36 20.4198L10.25 20.6098C9.78 21.3998 8.76 21.6798 7.97 21.2098L6.24 20.2198C5.33 19.6998 5.02 18.5298 5.54 17.6298C6.45 16.0598 5.71 14.7798 3.9 14.7798C2.85 14.7798 2 13.9198 2 12.8798Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.5cb4ce68d84633af72bcf30c11373134.svg";
export { ForwardRef as ReactComponent };